// External libraries
import gql from 'graphql-tag';

export const CART_AMOUNTS_FRAGMENT = gql`
  fragment CartAmounts on Cart {
    amounts {
      discount {
        currencyValue
        currencyFormat
      }
      handlingFee {
        currencyValue
        currencyFormat
      }
      insurance {
        currencyValue
        currencyFormat
      }
      shipping {
        currencyValue
        currencyFormat
      }
      shippingAndHandling {
        currencyValue
        currencyFormat
      }
      shippingDiscount {
        currencyValue
        currencyFormat
      }
      subtotal {
        currencyValue
        currencyFormat
      }
      tax {
        currencyValue
        currencyFormat
      }
      total {
        currencyCode
        currencyFormat
        currencyFormatSymbolISOCurrency
        currencyValue
      }
    }
  }
`;
